<template>
  <div>
    <CRow class="justify-content-between mb-3">
      <CCol sm="auto"
        ><div class="ui-type-display-lg">
          {{ $t("user.profile.mail.title") }}
        </div>
      </CCol>
      <CCol sm="auto">
        <CButton color="primary" @click="onAddEmail()">
          {{ $t("user.profile.mail.addbtn") }}
        </CButton>
      </CCol>
    </CRow>

    <CCard>
      <CCardBody>
        <CAlert v-if="error.hasGeneralErrors()" color="danger" class="mb-3">
          {{ error.general().join(" ") }}
        </CAlert>
        <Header
          :data="[
            'Email',
            $t('models.email.verified'),
            $t('models.email.primary'),
            $t('common.table.actions'),
          ]"
        />
        <Row
          v-for="(item, index) in emailData"
          :key="index"
          :data="[
            { data: item.email, type: 'text' },
            { data: item.verified, type: 'boolean' },
            { data: item.primary, type: 'boolean' },
            { data: '', type: 'actions' },
          ]"
        >
          <template #actions>
            <div
              class="d-flex justify-content-end"
              role="button"
              v-if="!item.primary"
            >
              <dropdown-menu :items="getActions(item)" :select="onActionSelect">
                <font-awesome-icon icon="ellipsis-h" />
              </dropdown-menu>
            </div>
          </template>
        </Row>
      </CCardBody>
    </CCard>

    <CModal :show="modal.show" :closeOnBackdrop="false" :centered="true">
      <template #header>
        <h5 class="modal-title">{{ $t("user.profile.mail.modal.title") }}</h5>
      </template>

      <CAlert v-if="modal.error.hasGeneralErrors()" color="danger" class="mb-3">
        {{ modal.error.general().join(" ") }}
      </CAlert>

      <form action="" @submit.prevent="addEmail">
        <CInput
          v-model="modal.form.email"
          :label="this.$t('models.email.email')"
          type="email"
          :isValid="modal.error.isValidField('email')"
          :invalidFeedback="modal.error.fieldError('email')"
          required
        />
      </form>

      <template #footer>
        <CButton
          color="primary"
          variant="outline"
          @click.prevent="closeModal"
          >{{ $t("common.editor.cancel") }}</CButton
        >
        <vue-ladda
          :loading="modal.loading"
          data-style="zoom-in"
          button-class="btn btn-primary px-4"
          @click.prevent="addEmail"
          >{{ $t("common.editor.confirm") }}</vue-ladda
        >
      </template>
    </CModal>
  </div>
</template>

<script>
import Vue from "vue";
import errorResponse from "../../../helpers/error";
import {
  apiGet,
  apiPost,
  apiDelete,
  apiPatch,
} from "../../../helpers/apiHelper";
import Header from "../../../common/table/Header.vue";
import Row from "../../../common/table/Row.vue";

export default Vue.extend({
  name: "Email",

  components: { Header, Row },

  data() {
    return {
      emailData: [],
      error: errorResponse(),
      modal: {
        show: false,
        loading: false,
        error: errorResponse(),
        form: {
          email: "",
        },
      },
    };
  },

  methods: {
    getActions(item) {
      return [
        {
          id: "MARK_AS_PRIMARY",
          item: item,
          text: this.$t("user.profile.mail.actions.primary"),
        },
        {
          id: "DELETE",
          item: item,
          text: this.$t("user.profile.mail.actions.delete"),
        },
      ];
    },

    onActionSelect(action) {
      console.log(action);
      if (action.item.id === "DELETE") {
        if (
          confirm(
            this.$t("user.profile.mail.actions.delete_confirm", [
              action.item.item.email,
            ])
          ) == true
        ) {
          this.onRemove(action.item);
        }
      }

      if (action.item.id === "MARK_AS_PRIMARY") {
        this.onMarkAsPrimary(action.item);
      }
    },

    onAddEmail() {
      this.modal.error.reset();
      this.modal.form.email = "";
      this.modal.show = true;
    },

    closeModal() {
      this.modal.show = false;
    },

    async addEmail() {
      const requestParams = {
        email: this.modal.form.email,
      };
      this.modal.error.reset();

      const response = await apiPost("auth_email", requestParams);
      if (response && (response.status === 200 || response.status === 201)) {
        this.$store.dispatch("toaster/add", {
          title: "OK!",
          text: this.$t("user.profile.mail.primary_success"),
          color: "success",
          autohide: true,
        });
        this.modal.show = false;
        await this.fetchData();
      } else if (response && response.errors) {
        this.modal.error.set(response.errors);
      } else {
        console.error("Unexpected response:", response);
      }
    },

    onRemove(data) {
      const item = data.item;
      this.removeEmail(item.id);
    },

    onMarkAsPrimary(data) {
      const item = data.item;
      this.markAdPrimaryEmail(item.id);
    },

    async removeEmail(id) {
      this.error.reset();

      const response = await apiDelete("auth_email", id);
      if (response && response.status === 200) {
        this.$store.dispatch("toaster/add", {
          title: "OK!",
          text: this.$t("user.email.toast.success"),
          color: "success",
          autohide: true,
        });
        this.modal.show = false;
        await this.fetchData();
      } else if (response && response.errors) {
        this.modal.error.set(response.errors);
      } else {
        console.error("Unexpected response:", response);
      }
    },

    async markAdPrimaryEmail(id) {
      const requestParams = {
        id: id,
        primary: true,
      };
      this.error.reset();

      const response = await apiPatch("auth_email", id, requestParams);
      if (response && response.status === 200) {
        this.$store.dispatch("toaster/add", {
          title: "OK!",
          text: this.$t("user.profile.mail.primary_success"),
          color: "success",
          autohide: true,
        });
        this.modal.show = false;
        await this.fetchData();
      } else if (response && response.errors) {
        this.error.set(response.errors);
      } else {
        console.error("Unexpected response:", response);
      }
    },

    async fetchData() {
      const response = await apiGet("auth_email");
      if (response && response.data) {
        this.emailData = response.data.payload.Items;
      }
    },
  },
  async created() {
    await this.fetchData();
  },
});
</script>
